import { render, staticRenderFns } from "./AgilePickupDeclaredValuePackTable.vue?vue&type=template&id=bc0d43d8&scoped=true"
import script from "./AgilePickupDeclaredValuePackTable.vue?vue&type=script&lang=ts"
export * from "./AgilePickupDeclaredValuePackTable.vue?vue&type=script&lang=ts"
import style0 from "./AgilePickupDeclaredValuePackTable.vue?vue&type=style&index=0&id=bc0d43d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d43d8",
  null
  
)

export default component.exports